export default {
  "nav.home": "Home",
  "nav.categories": "Categories",
  "nav.articles": "Guides",
  "nav.faq": "FAQ",
  "nav.shopGuide": "Shopping Guide",

  "hero.eyebrow": "USFans Spreadsheet & Resource Hub",
  "hero.title": "USFans Spreadsheet — Find, Explore & Compare USFans Resources",
  "hero.subtitle": "Find organized USFans spreadsheet resources, creator lists, reviews, shipping guides, coupons and comparisons — all in one easy-to-navigate hub.",
  "hero.ctaPrimary": "USFans Spreadsheet",
  "hero.ctaSecondary": "Buy It Now",
  "hero.trust": "Independent Resource • Updated Information • Safety-Focused",
  "hero.searchPlaceholder": "Search spreadsheets, creators, shipping, coupons, reviews...",

  "categories.title": "Browse by Category",
  "categories.subtitle": "Jump straight to the products you are looking for on the main store.",
  "categories.dropdownLabel": "Select a category",
  "categories.view": "View category",

  "articles.title": "USFans Spreadsheet: Guides & Resources",
  "articles.subtitle": "Read our in-depth guides to understand how USFans spreadsheet resources, creator lists and comparisons work.",
  "articles.readMore": "Read the full guide",

  "faq.title": "Frequently Asked Questions",
  "faq.subtitle": "Quick, practical answers about USFans spreadsheet resources.",

  "cta.title": "Ready to Explore USFans Resources?",
  "cta.subtitle": "Explore our USFans spreadsheet resources, guides, comparisons and safety information — then head to the main store.",

  "footer.desc": "USFansLink is an independent resource hub for USFans spreadsheet links, creator lists, reviews, shipping guides, coupons and comparisons.",
  "footer.disclaimer": "USFansLink is an independent information resource. We are not affiliated with any brand unless explicitly stated.",
  "footer.rights": "All rights reserved.",
  "footer.explore": "Explore",
  "footer.categories": "Categories",
  "footer.language": "Language",

  "category.shoes": "Shoes",
  "category.hoodies": "Hoodies/Sweaters",
  "category.tshirts": "T-Shirts",
  "category.jackets": "Jackets",
  "category.pants": "Pants/Shorts",
  "category.headwear": "Headwear",
  "category.sets": "Sets",
  "category.underwear": "Underwear/Underpants",
  "category.jersey": "Jersey",
  "category.accessories": "Accessories",
  "category.bags": "Bags",
  "category.belts": "Belts",
  "category.perfumes": "Perfumes",
  "category.other": "Other Stuff",

  "common.backHome": "Back to home",
  "common.readArticle": "Read article",
  "common.published": "Published",
  "common.updated": "Updated",
  "common.author": "Author",
  "common.readTime": "min read",
  "common.onThisPage": "On this page",
  "common.relatedResources": "Related resources",
  "common.quickAnswer": "Quick answer",
  "common.faqShort": "FAQ",
};